/**
 * Keep inquiry + notices directly under the purchase CTA.
 * Does not move Easify nodes (moving them breaks option widgets / Swiper).
 * Re-runs a few times after load in case Easify injects between CTA and notices.
 */
(function () {
  function pinPurchaseMeta(stack) {
    if (!stack || stack.__pinningPurchaseMeta) return;

    var cta = stack.querySelector(
      '#addToCartButton, button.add-to-cart, button.made-to-order-btn, button.inquire-btn'
    );
    if (!cta || !stack.contains(cta)) return;

    var inquiry = null;
    var notices = null;
    Array.prototype.forEach.call(stack.children, function (child) {
      if (child.classList && child.classList.contains('product-inquiry')) {
        inquiry = child;
      } else if (child.hasAttribute && child.hasAttribute('data-product-purchase-notices')) {
        notices = child;
      }
    });

    if (!inquiry && !notices) return;

    var expectedFirst = inquiry || notices;
    var alreadyPinned =
      cta.nextElementSibling === expectedFirst &&
      (!inquiry || !notices || inquiry.nextElementSibling === notices);
    if (alreadyPinned) return;

    stack.__pinningPurchaseMeta = true;

    // Only relocate our meta nodes — never detach Easify wrappers.
    if (inquiry) cta.after(inquiry);
    if (notices) (inquiry || cta).after(notices);

    stack.__pinningPurchaseMeta = false;
  }

  function pinAll() {
    document.querySelectorAll('[data-product-purchase-actions]').forEach(pinPurchaseMeta);
  }

  function watch() {
    pinAll();
    if (window.__productPurchaseMetaObserver) return;

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        pinAll();
      });
    });

    document.querySelectorAll('[data-product-purchase-actions]').forEach(function (stack) {
      observer.observe(stack, { childList: true });
    });

    window.__productPurchaseMetaObserver = observer;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  window.addEventListener('load', pinAll);
  setTimeout(pinAll, 800);
  setTimeout(pinAll, 2000);

  document.addEventListener('shopify:section:load', function () {
    if (window.__productPurchaseMetaObserver) {
      window.__productPurchaseMetaObserver.disconnect();
      window.__productPurchaseMetaObserver = null;
    }
    watch();
  });
})();
